export default "__VITE_ASSET__CAkWC6KQ__"